__turbopack_context__.v({
  "back": "PortalEventRegistration-module__6IDzeW__back",
  "confirmation": "PortalEventRegistration-module__6IDzeW__confirmation",
  "confirmationActions": "PortalEventRegistration-module__6IDzeW__confirmationActions",
  "confirmationIcon": "PortalEventRegistration-module__6IDzeW__confirmationIcon",
  "content": "PortalEventRegistration-module__6IDzeW__content",
  "dateTile": "PortalEventRegistration-module__6IDzeW__dateTile",
  "description": "PortalEventRegistration-module__6IDzeW__description",
  "details": "PortalEventRegistration-module__6IDzeW__details",
  "endDate": "PortalEventRegistration-module__6IDzeW__endDate",
  "error": "PortalEventRegistration-module__6IDzeW__error",
  "eventIdentity": "PortalEventRegistration-module__6IDzeW__eventIdentity",
  "eyebrow": "PortalEventRegistration-module__6IDzeW__eyebrow",
  "fields": "PortalEventRegistration-module__6IDzeW__fields",
  "form": "PortalEventRegistration-module__6IDzeW__form",
  "formHeading": "PortalEventRegistration-module__6IDzeW__formHeading",
  "fullWidth": "PortalEventRegistration-module__6IDzeW__fullWidth",
  "guestHint": "PortalEventRegistration-module__6IDzeW__guestHint",
  "heading": "PortalEventRegistration-module__6IDzeW__heading",
  "layout": "PortalEventRegistration-module__6IDzeW__layout",
  "occupancy": "PortalEventRegistration-module__6IDzeW__occupancy",
  "page": "PortalEventRegistration-module__6IDzeW__page",
  "quantity": "PortalEventRegistration-module__6IDzeW__quantity",
  "receipt": "PortalEventRegistration-module__6IDzeW__receipt",
  "spin": "PortalEventRegistration-module__6IDzeW__spin",
  "spinner": "PortalEventRegistration-module__6IDzeW__spinner",
  "stepper": "PortalEventRegistration-module__6IDzeW__stepper",
  "submitArea": "PortalEventRegistration-module__6IDzeW__submitArea",
  "summary": "PortalEventRegistration-module__6IDzeW__summary",
  "unavailable": "PortalEventRegistration-module__6IDzeW__unavailable",
});
